module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RhO1Ql/tc-custom/9781685503222.jpg?1723406169567",
      "alt": "This image is the cover for the book The Setup"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Setup\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Three years ago, Dax Howard got out of a bad relationship and swore never to date again. He loves his picturesque cabin outside Nortown and is looking forward to three weeks of quiet over the holidays. He hadn't foreseen a stranger turning in on his driveway in the middle of a snowstorm, claiming he's there for a date."), _c('br'), _c('br'), _vm._v("Ellis Rush has risked his neck driving in a snowstorm to meet his friend Daniel and his boyfriend Dom for a double date he agreed to go on as a favor. Reaching the destination, he can't see Daniel's car anywhere, and when the mountain of a man opening the door says he's never agreed to go on a double date, Ellis realizes he's been played."), _c('br'), _c('br'), _vm._v("The more Ellis explains the situation, the more annoyed Dax gets. Dom is one of his closest friends, and he does not appreciate the setup, no matter how intrigued he is by Ellis. Since the roads are undrivable, Dax invites Ellis to stay, and together they plot their revenge. Cooking for Ellis, kissing Ellis, and sleeping next to Ellis isn't the same thing as dating, is it?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ofelia Gränd\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0